'use client';

import { ReactNode, useEffect, useState } from 'react';
import { useNotifications } from '@/hooks/useNotifications';
import dynamic from 'next/dynamic';

const RequestNotificationPermissionModal = dynamic(
  () => import('@/components/modals/RequestNotificationPermissionModal')
);

interface Props {
  children: ReactNode;
}

export function NotificationsProvider({ children }: Props) {
  const { permission, supported, requestPermission } = useNotifications();
  const [prompted, setPrompted] = useState(false);

  // show the modal only once, and only if browser supports notifications
  useEffect(() => {
    const hasDismissed = localStorage.getItem('notification_dismissed');
    if (!prompted && supported && permission === 'default' && !hasDismissed) {
      setPrompted(true);
    }
  }, [supported, permission, prompted]);

  const handleClose = () => {
    localStorage.setItem('notification_dismissed', 'true');
    setPrompted(false);
  };

  if (!supported) {
    // silently do nothing if the browser doesn't support notifications
    return children;
  }

  return (
    <>
      {permission === 'default' && prompted && (
        <RequestNotificationPermissionModal
          onRequestPermission={() => void requestPermission()}
          onClose={handleClose}
        />
      )}
      {children}
    </>
  );
}
